import { render, staticRenderFns } from "./SpeedFactorPanel.vue?vue&type=template&id=35620fd8"
import script from "./SpeedFactorPanel.vue?vue&type=script&lang=ts"
export * from "./SpeedFactorPanel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports